import { render } from "./ProductionInProgress.vue?vue&type=template&id=8d4538cc&scoped=true"
import script from "./ProductionInProgress.vue?vue&type=script&lang=js"
export * from "./ProductionInProgress.vue?vue&type=script&lang=js"

import "./ProductionInProgress.vue?vue&type=style&index=0&id=8d4538cc&scoped=true&lang=css"

import exportComponent from "/home/dyam/Documentos/LYRASHOES/mi-stock-lyrashoes-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d4538cc"]])

export default __exports__